<template>
    <div id="contenedor-listado-mobiles">
        <template
            v-for="(licitacion, index) in listadoLicitaciones">
            <v-card
                :key="index"
                class="mb-2">
                <v-card-title
                  class="justify-space-between">
                  <div
                    class="d-inline-block text-truncate">
                    {{ licitacion.numero }}
                  </div>
                  <div
                    class="d-inline-block">
                    <opciones
                      :licitacion="licitacion">
                    </opciones>
                  </div>
                </v-card-title>
                <v-card-text>
                    {{ licitacion.objeto }}
                </v-card-text>
            </v-card>
        </template>
    </div>
</template>

<script>

import Opciones from './Opciones.vue';

export default {
  name: 'ListadoMobiles',
  props: {
    listadoLicitaciones: {
      type: Array,
      required: true,
    },
  },
  components: {
    Opciones,
  },
  data() {
    return {
    };
  },
};
</script>

<style lang="scss">

</style>
